module.exports = __webpack_public_path__ + "static/img_1977-c4c299c4676bcaaee7c9757d2041c9de.webp";